import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    Input,
    Label,
    Row,
    Button,
    Modal,
    ModalBody,
    ModalHeader,
    Spinner,
    CardHeader,
    CardFooter,
} from "reactstrap";
import {
    useCreateInspectionReportMutation,
    useUpdateInspectionReportByIdMutation,
    useGetInspectionReportByIdQuery,
    useUpdateInspectionReportMutation,
    useGetTypeofInspectionQuery,
    usePostInspectionReportByIdMutation
} from "slices/InspectionReport/InspectionReportSlice";
import classNames from "classnames";
import BreadCrumb from "Components/Common/BreadCrumb";
import Dropzone from "react-dropzone";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useGetEmployeeDropDownByProjectQuery } from "slices/employee/employeeSlice";
import { useGetprojectByIdQuery } from "slices/projects/projectSlice";
import { useFormik } from "formik";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import * as Yup from "yup";
import moment from "moment";
import { number } from "prop-types";
import { formatDateTime } from "helpers/date_utils";
import { getStatusClass } from "utils/CommonUtils";
import { useGetCompaniesQuery } from "slices/InspectionReport/InspectionReportSlice";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import { FreeMode, Navigation } from "swiper/modules";
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import { getErrorText } from "helpers/error_message";
import ValidationAlertStatic from "pages/SafetyApp/ValidationAlertStatic";
import { toast } from "react-toastify";

type CreateReportResult = {
    id: number;
    error?: FetchBaseQueryError;
};


// Define the types for form data
type FormData = {
    parent_company: number;
    project: number;
    type_of_inspection: string;
    start_date: string;
    end_date: string;
    due_date: string;
    report_status: number;
    inspector_employee_uuid: string;
};

export interface InspectionReportRowDetail {
    inspection_report: number;
    inspection_sub_company: string;
    site_location: string;
    name_of_person_incharge: number;
    designation: string;
    comments_report1: string | null;
    attachment1: string | null;
    inspection_row_id: number | null;
    work_assigned: string,
    is_bad_practice: boolean,
    observation: string,
    recommendation: string,
    corrective_actions: string,
    preventive_actions: string,
    title:string,
}

const InspectionReportForm: React.FC = () => {
    const { project, reportNo: reportNoFromURL } = useParams<{
        project: string;
        reportNo?: string;
    }>();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(1);
    const [modalOpen, setModalOpen] = useState(false);
    const [correctionModalOpen, setCorrectionModalOpen] = useState(false);
    const [practiceType, setPracticeType] = useState("");
    const [currentUser, setCurrentUser] = useState({});
    console.log('currentUser', currentUser);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [viewReport, setViewReport] = useState<boolean>(false);
    const [reportId, setReportId] = useState<string | null>(null);
    const [editingReportId, setEditingReportId] = useState<number | null>(null);
    const [OpenAccordionItem, setOpenAccordionItem] = useState<string>("");
    const [modalFormData, setModalFormData] = useState<any>({
        site_location: "",
        inspection_sub_company: "",
        name_of_person_incharge: "",
        designation: "",
        comments_report1: "",
        comments_report2: "",
        attachment1: null,
        attachment2: null,
        work_assigned: "",
        recommendation: "",
        corrective_actions: "",
        preventive_actions: "",
    });

    const [searchParams, setSearchParams] = useSearchParams();

    const [geoPermission, setGeoPermission] = React.useState<boolean>(false);
    const [modalBackDrop, setModalBackDrop] = useState<boolean>(false);
    const [cardView, setCardView] = useState<boolean>(false);
    const [validationMessages, setValidationMessages] = useState<string[]>([]);
    const [location, setLocation] = useState<{
        latitude: number | null;
        longitude: number | null;
    }>({ latitude: null, longitude: null });

    //report Filter

    // Function to toggle accordion items
    const toggleAccordion = (id: string) => {
        setOpenAccordionItem((prev) => (prev === id ? "" : id));
    };

    const { data: projectData, isLoading: projectLoading } = useGetprojectByIdQuery(
        project, { skip: !project }
    );

    const {
        data: reportData,
        isLoading,
        isError: error,
        refetch: reportDataRefetch,
    } = useGetInspectionReportByIdQuery(reportId || 0, { skip: !reportId });

    const [filteredData, setFilteredData] = useState(reportData?.inspection_report_detail);
    const [activeFilter, setActiveFilter] = useState(null);

    // Count the number of Good and Bad Practices
    const badPracticeCount = reportData?.inspection_report_detail.filter((item: { report_type: number; }) => item.report_type === 2).length;
    const goodPracticeCount = reportData?.inspection_report_detail.filter((item: { report_type: number; }) => item.report_type === 1).length;

    // Function to filter data
    const filterReports = (type: any) => {
        if (activeFilter === type) {
            // If already selected, remove the filter
            setFilteredData(reportData?.inspection_report_detail);
            setActiveFilter(null);
        } else {
            // Apply filter based on report_type
            setFilteredData(reportData?.inspection_report_detail?.filter((item: { report_type: any; }) => item.report_type === type));
            setActiveFilter(type);
        }
    };

    useEffect(() => {
        // Check if create_task is true in the URL search params
        if (searchParams.get("view_report") === "true") {
            setCardView(true);
            // Update the URL to set create_task to false
            searchParams.set("view_report", "true");
            setSearchParams(searchParams);
        }
    }, [searchParams, setSearchParams]);

    console.log('Card-View',searchParams);

    useEffect(() => {
        setFilteredData(reportData?.inspection_report_detail);
    }, [reportData?.inspection_report_detail]);

    const { data: typeofInspection } = useGetTypeofInspectionQuery(undefined);
    const { data: companiesData } = useGetCompaniesQuery();

    const [createReport, { isLoading: isCreating }] = useCreateInspectionReportMutation();
    const [createReportbyId, { isLoading: isCreatingbyId }] = usePostInspectionReportByIdMutation();

    const [updateReport, { isLoading: isUpdating }] = useUpdateInspectionReportMutation();
    const [
        updateInspectionReportRowbyId,
        { isLoading: patchReportRowByIdloading },
    ] = useUpdateInspectionReportByIdMutation();

    useEffect(() => {
        if (reportNoFromURL) {
            setReportId(reportNoFromURL)
            setViewReport(true)
        }
    }, [reportNoFromURL]);

    useEffect(() => {
        // Retrieve the authUser object from sessionStorage and parse it
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            try {
                const parsedAuthUser = JSON.parse(authUser);
                console.log('parsedAuthUser', parsedAuthUser)
                const employeeUUID = parsedAuthUser.employee_id || "";
                console.log('employeeUUID', employeeUUID)
                setCurrentUser(parsedAuthUser);
                if (employeeUUID) {
                    formik.setFieldValue("inspector", employeeUUID);
                    formik.setFieldValue("report_status", 1);
                }
            } catch (error) {
                console.error("Failed to parse authUser from local storage:", error);
            }
        }
    }, []);

    const getLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                    setGeoPermission(true);
                },
                (err) => {
                    setValidationMessages((prev) => {
                        const errorMessage = getErrorText("location-disabled");
                        return prev.includes(errorMessage) ? prev : [...prev, errorMessage];
                    });
                    setModalBackDrop(true);
                    setGeoPermission(false);
                },
                { enableHighAccuracy: true },
            );
        } else {
            setValidationMessages((prev) => {
                const errorMessage = getErrorText("location-not-supported");
                return prev.includes(errorMessage) ? prev : [...prev, errorMessage];
            });
            setModalBackDrop(true);
            setGeoPermission(false);
        }
    };

    useEffect(() => {
        setValidationMessages([]);
        getLocation();
    }, [project]);



    const formik = useFormik({
        initialValues: {
            project: Number(project),
            start_date: reportData?.start_date || "",
            end_date: reportData?.end_date || "",
            due_date: reportData?.due_date || "",
            type_of_inspection: reportData?.type_of_inspection,
            other_inspection_type: reportData?.other_inspection_type,
        },
        validationSchema: Yup.object({
            start_date: Yup.string()
                .required("Start date is required")
                .test(
                    "is-not-in-past",
                    "Start date cannot be in the past",
                    function (value) {
                        console.log("value", value);

                        if (!value) return true; // Skip validation if no date is provided
                        const inputDate = moment(value, "YYYY-MM-DD").startOf("day"); // Only date part
                        const today = moment().startOf("day");
                        return inputDate.isSameOrAfter(today); // Compare only dates
                    },
                ),
            end_date: Yup.date()
                .required("End date is required")
                .test(
                    "is-same-or-next-day",
                    "End date must be the same or the next day as the start date",
                    function (value) {
                        const { start_date_of_work } = this.parent; // Access other fields
                        if (!start_date_of_work || !value) return true; // Skip if either date is empty

                        const startDate = moment(start_date_of_work, "YYYY-MM-DD").startOf(
                            "day",
                        );
                        const endDate = moment(value, "YYYY-MM-DD").startOf("day");

                        // Check if the endDate is same or next day compared to startDate
                        return (
                            endDate.isSame(startDate) ||
                            endDate.isSame(startDate.add(1, "day"))
                        );
                    },
                ),

            type_of_inspection: Yup.string()
                .required("Type of inspection is required"),

            // Conditional validation for "other_inspection_type"
            other_inspection_type: Yup.string()
                .when("type_of_inspection", {
                    is: "other",
                    then: (schema) => schema.required("Please specify the other inspection type"),
                    otherwise: (schema) => schema.notRequired(),
                }),

        }),

        onSubmit: async (values) => {
            try {
                const payload = {
                    ...values,
                    type_of_inspection: Number(values.type_of_inspection),
                    other_inspection_type: values.other_inspection_type,
                    project: Number(project),
                    // location: location,
                    latitude: location.latitude,
                    longitude: location.longitude,
                };
                let response;

                console.log('payload', payload)

                if (reportId) {
                    response = await updateReport({
                        id: reportId,
                        reportData: payload,
                    }).unwrap();
                    setViewReport(true)
                } else {
                    // Create new report
                    response = await createReport(payload).unwrap();
                    setViewReport(true)
                    navigate(
                        `/inspection-report/${project}/${response.report_id}`,
                    );
                    //   setActiveTab(activeTab + 1);
                    console.log("CreateReportResult", response);

                    if (response) {
                        console.log("Report created with ID:", response.report_id);
                        setReportId(response?.report_id);
                        reportDataRefetch();
                        setViewReport(true)
                        navigate(
                            `/inspection-report/${project}/${response.report_id}`,
                        );
                    }
                }
                // setActiveTab(activeTab + 1);
            } catch (error) {
                console.error("Error updating or creating report:", error);
                toast.error("Failed to update Inspection Report!");
            }
        }
    });

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0"); // Add 1 to month since it's zero-indexed
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };


    useEffect(() => {
        if (!isLoading && reportData) {
            const {
                type_of_inspection,
                other_inspection_type,
                start_date,
                project,
                end_date,
                due_date
            } = reportData;

            formik.setValues({
                project: project,
                type_of_inspection: type_of_inspection || "",
                other_inspection_type: other_inspection_type || "",
                start_date: start_date || getCurrentDate(),
                end_date: end_date || "",
                due_date: due_date || "",
            });
        }
    }, [isLoading, reportData, project]);

    const { data: employeeData } = useGetEmployeeDropDownByProjectQuery(
        formik.values.project, { skip: !formik.values.project }
    );

    const handlePracticeButtonClick = (type: React.SetStateAction<string>) => {
        setPracticeType(type);
        practiceFormik.resetForm();
        setSelectedFiles([]);
        setModalOpen(true);
    };

    const handleCorrectionButtonClick = (id: any) => {
        setEditingReportId(id);
        correctionFormik.resetForm();
        setSelectedFiles([]);
        setCorrectionModalOpen(true);
    };

    const allBadPracticeCompleted = reportData?.inspection_report_detail
        .filter((report: { report_type: number; }) => report.report_type === 2) // Get only report_type 2
        .every((report: { report_status_name: string; }) => report.report_status_name === "Work Completed"); // Check if all have "Work Completed"

    const handleSubmitButtonClick = async (id: any) => {
        const payload = {
            // location: location,
            latitude: location.latitude,
            longitude: location.longitude,
            report_status: id
        };
        let response = await updateReport({
            id: reportId,
            reportData: payload,
        }).unwrap();
        console.log('submit---response', response);
        navigate(
            `/report-list`
        );
    };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const correctionToggleModal = () => {
        setCorrectionModalOpen(!correctionModalOpen);
    };

    useEffect(() => {
        if (!isLoading && modalFormData) {
            const {
                site_location,
                title,
                name_of_person_incharge,
                work_assigned,
                comments_report1,
                is_bad_practice,
                observation,
                recommendation,
                corrective_actions,
                attachment1,
                preventive_actions,
                report_type,
                inspection_report,
                name_of_person_incharge_uuid,
                target_date,
            } = modalFormData;

            practiceFormik.setValues({
                site_location: site_location || "",
                title: title ||  "",
                name_of_person_incharge: name_of_person_incharge || "",
                name_of_person_incharge_uuid: name_of_person_incharge_uuid || "",
                target_date: target_date || "",
                comments_report1: comments_report1 || "",
                report_type: report_type,  // Ensuring boolean value
                observation: observation || "",
                recommendation: recommendation || "",
                // attachment1: attachment1 || null,
                corrective_actions: corrective_actions || "",
                preventive_actions: preventive_actions || "",
                inspection_report: reportId,
                checkedFields: {
                    observation: false,
                    recommendation: false,
                    comments_report1: false,
                },
            });
        }
    }, [isLoading, modalFormData, project]);



    const practiceFormik = useFormik({
        initialValues: {
            inspection_report: reportId,
            site_location: "",
            title: modalFormData?.title,
            //@ts-ignore
            name_of_person_incharge: modalFormData?.name_of_person_incharge,
            name_of_person_incharge_uuid: modalFormData?.name_of_person_incharge_uuid,
            target_date: modalFormData?.target_date,
            comments_report1: modalFormData?.comments_report1 || "",
            report_type: practiceType || modalFormData?.report_type,
            observation: modalFormData?.observation || "",
            recommendation: modalFormData?.recommendation || "",
            corrective_actions: modalFormData?.corrective_actions || "",
            preventive_actions: modalFormData?.preventive_actions || "",
            // attachment1: modalFormData?.attachment1 || null,
            checkedFields: {
                observation: false,
                recommendation: false,
                comments_report1: false,
            },
        },
        validationSchema: Yup.object({
            site_location: Yup.string().required('Location is required.'),
            title:Yup.string().required('Title is required'),
            name_of_person_incharge: Yup.string().required('Assignee is required'),
            target_date: Yup.string().required("Target Date is required"),
            checkedFields: Yup.object().test(
                "at-least-one-checked",
                "At least one field must be checked!",
                (value) => Object.values(value).some((checked) => checked)
            ),
        }),

        onSubmit: async (values) => {
            try {
                const inspectionReportDetail: any = {
                    // ...(editingReportId !== null && {
                    //     inspection_row_id: editingReportId,
                    // }),
                    // ...(reportDetailId !== null && {
                    //     inspection_report: reportDetailId,
                    // }),
                    inspection_report: reportData?.id,
                    site_location: values?.site_location,
                    title: values?.title,
                    inspection_sub_company: modalFormData?.inspection_sub_company,
                    //@ts-ignore
                    name_of_person_incharge: values?.name_of_person_incharge || modalFormData?.name_of_person_incharge,
                    //@ts-ignore
                    name_of_person_incharge_uuid: values?.name_of_person_incharge_uuid || modalFormData?.name_of_person_incharge_uuid,
                    report_type: practiceType,
                    observation: values?.observation || "",
                    recommendation: values?.recommendation || "",
                    corrective_actions: values?.corrective_actions || "",
                    preventive_actions: values?.preventive_actions || "",
                    comments_report1: values?.comments_report1 || null,
                    attachment1: selectedFiles || null,
                    target_date: values?.target_date || "",
                    report_status: 3,
                };
                let response;
                if (editingReportId) {
                    // Constructing the data to match the expected API format
                    response = await updateInspectionReportRowbyId({
                        id: editingReportId,
                        reportData: inspectionReportDetail,
                        // ...(editingReportId !== null && { inspection_row_id: editingReportId }),
                    }).unwrap();
                    toggleModal();
                    reportDataRefetch();
                    setEditingReportId(null);
                    practiceFormik.resetForm();
                } else {
                    response = await createReportbyId(inspectionReportDetail).unwrap();

                    console.log('create--response', response);

                    toggleModal();
                    reportDataRefetch();
                }
                // setEditingReportId(null);
            } catch (error) {
                console.error("Error updating report in modal:", error);
                setEditingReportId(null);
                toggleModal();
                toast.error("Failed to update Inspection Report!");
            }
        }
    });

    useEffect(() => {
        if (!isLoading && modalFormData) {
            const {
                comments_report2,
                corrective_actions,
                attachment2,
                preventive_actions,
                inspection_report,
                name_of_person_incharge_name,
            } = modalFormData;

            correctionFormik.setValues({
                comments_report2: comments_report2 || "",
                // attachment1: attachment1 || null,
                corrective_actions: corrective_actions || "",
                preventive_actions: preventive_actions || "",
                inspection_report: reportId,
                name_of_person_incharge_name: name_of_person_incharge_name || "",
                checkedFields: {
                    corrective_actions: false,
                    preventive_actions: false,
                    comments_report2: false,
                },
            });
        }
    }, [isLoading, modalFormData, project]);


    const correctionFormik = useFormik({
        initialValues: {
            inspection_report: reportId,
            comments_report2: modalFormData?.comments_report2 || "",
            corrective_actions: modalFormData?.corrective_actions || "",
            preventive_actions: modalFormData?.preventive_actions || "",
            name_of_person_incharge_name: modalFormData?.name_of_person_incharge_name || "",
            checkedFields: {
                corrective_actions: false,
                preventive_actions: false,
                comments_report2: false,
            },
        },
        validationSchema: Yup.object({
            checkedFields: Yup.object().test(
                "at-least-one-checked",
                "At least one field must be checked!",
                (value) => Object.values(value).some((checked) => checked)
            ),
            // comments_report2: Yup.string().required('Comments is required'),
            // corrective_actions: Yup.string().required('Corrective action is required'),
            // preventive_actions: Yup.string().required('Preventive action is required'),
        }),

        onSubmit: async (values) => {
            try {
                const inspectionReportDetail: any = {
                    inspection_report: reportData?.id,
                    corrective_actions: values?.corrective_actions || "",
                    preventive_actions: values?.preventive_actions || "",
                    comments_report2: values?.comments_report2 || "",
                    attachment2: selectedFiles || null,
                    report_status: 6,
                };
                let response;
                if (editingReportId) {
                    // Constructing the data to match the expected API format
                    response = await updateInspectionReportRowbyId({
                        id: editingReportId,
                        reportData: inspectionReportDetail,
                    }).unwrap();
                    correctionToggleModal();
                    reportDataRefetch();
                    setEditingReportId(null);
                    correctionFormik.resetForm();
                }
                // setEditingReportId(null);
            } catch (error) {
                console.error("Error updating report in modal:", error);
                setEditingReportId(null);
                correctionFormik.resetForm();
                correctionToggleModal();
                toast.error("Failed to update Inspection Report!");
            }
        }
    });


    if (isLoading) {
        return (
            <React.Fragment>
                <Container fluid>
                    <div className="page-content" style={{ height: "80vh" }}>
                        {" "}
                        {/* Full viewport height */}
                        <Container fluid className="h-100">
                            <Row className="h-100 d-flex justify-content-center align-items-center">
                                <Col lg={12} className="text-center">
                                    <Spinner color="primary"></Spinner> <br /> <br />
                                    <span className="text-muted">
                                        Fetching Inspection Permit Information...
                                    </span>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Container>
            </React.Fragment>
        );
    }


    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Inspection Report" breadcrumbItem="Inspection Report" />
                <Row>
                    <Col lg={12}>
                        <Card>
                            {viewReport &&
                                <>
                                    <Card>
                                        <CardHeader className="d-flex align-items-between justify-content-between">
                                            <h5 className="mt-2">Inspection Report Details</h5>
                                            {
                                            //@ts-ignore
                                            reportData?.report_status_name !== "Open" && currentUser?.employee_uuid === reportData?.inspector_uuid && (
                                                <Button
                                                    color="primary"
                                                    className=" btn-sm"
                                                    onClick={() => { setViewReport(false) }}
                                                >
                                                    <i className="ri-pencil-fill fs-12 edit-task-status-class"></i> Edit
                                                </Button>
                                            )}

                                        </CardHeader>
                                        <CardBody>
                                            <div className="text-muted">

                                                <div className="pt-3 border-top border-top-dashed mt-4">
                                                    <Row>
                                                        <Col lg={3} sm={6}>
                                                            <div>
                                                                <p className="mb-2 text-uppercase fw-medium">
                                                                    Report ID :
                                                                </p>
                                                                <h5 className="fs-15 mb-0">
                                                                    {reportData?.report_id}
                                                                </h5>
                                                            </div>
                                                        </Col>
                                                        <Col lg={3} sm={6}>
                                                            <div>
                                                                <p className="mb-2 text-uppercase fw-medium">
                                                                    Project :
                                                                </p>
                                                                <h5 className="fs-15 mb-0">
                                                                    {reportData?.project_name}
                                                                </h5>
                                                            </div>
                                                        </Col>
                                                        {reportData?.company_name && (
                                                        <Col lg={3} sm={6}>
                                                        <div>
                                                            <p className="mb-2 text-uppercase fw-medium">
                                                                Company Name :
                                                            </p>
                                                            <h5 className="fs-15 mb-0">
                                                                {reportData.company_name}
                                                            </h5>
                                                        </div> 
                                                        </Col>
                                                        )}
                                                        {reportData?.sub_company_name && (
                                                        <Col lg={3} sm={6}>
                                                        <div>
                                                            <p className="mb-2 text-uppercase fw-medium">
                                                                Sub Company Name :
                                                            </p>
                                                            <h5 className="fs-15 mb-0">
                                                                {reportData.sub_company_name}
                                                            </h5>
                                                        </div>
                                                        </Col>
                                                        )}
                                                    </Row>
                                                </div>

                                                <div className="pt-3 border-top border-top-dashed mt-4">
                                                    <Row>
                                                    <Col lg={3} sm={6}>
                                                            <div>
                                                                <p className="mb-2 text-uppercase fw-medium">
                                                                    Type of Inspection :
                                                                </p>
                                                                <h5 className="fs-15 mb-0">
                                                                    {reportData?.type_of_inspection_name}
                                                                </h5>
                                                            </div>
                                                        </Col>
                                                        {reportData?.other_insception_type &&
                                                            <Col lg={3} sm={6}>
                                                                <div>
                                                                    <p className="mb-2 text-uppercase fw-medium">
                                                                        Other Inspection Type :
                                                                    </p>
                                                                    <h5 className="fs-15 mb-0">
                                                                        {reportData?.other_insception_type}
                                                                    </h5>
                                                                </div>
                                                            </Col>
                                                        }
                                                        
                                                        <Col lg={3} sm={6}>
                                                            <div>
                                                                <p className="mb-2 text-uppercase fw-medium">
                                                                    Start Date :
                                                                </p>
                                                                <h5 className="fs-15 mb-0">
                                                                    {reportData?.start_date}
                                                                </h5>
                                                            </div>
                                                        </Col>
                                                        <Col lg={3} sm={6}>
                                                            <div>
                                                                <p className="mb-2 text-uppercase fw-medium">
                                                                    End Date :
                                                                </p>
                                                                <h5 className="fs-15 mb-0">
                                                                    {reportData?.end_date}
                                                                </h5>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </>
                            }
                            {!viewReport &&
                                <Card>
                                    <CardHeader className="d-flex align-items-between justify-content-between">
                                        <h5 className="mt-2">Inspection Report Informations</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Form onSubmit={formik.handleSubmit}>
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Label htmlFor="project_name" className="form-label">Project</Label>
                                                    <Input
                                                        type="text"
                                                        className="form-control"
                                                        id="project_name"
                                                        name="inspector"
                                                        value={projectData?.project_name || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <Label htmlFor="inspector" className="form-label">Work Inspected By</Label>
                                                    <Input
                                                        type="text"
                                                        className="inspector"
                                                        id="inspector"
                                                        name="inspector"
                                                        //@ts-ignore
                                                        value={currentUser?.employee_full_name || ""}
                                                        readOnly
                                                        disabled
                                                    />

                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={6}>
                                                    <Label htmlFor="type_of_inspection" className="form-label">
                                                        Inspection Type <span className="text-danger">*</span>
                                                    </Label>

                                                    <Input
                                                        type="select"
                                                        className="form-select"
                                                        id="type_of_inspection"
                                                        name="type_of_inspection"
                                                        value={formik.values.type_of_inspection}
                                                        onChange={(e) => {
                                                            formik.handleChange(e);
                                                            if (e.target.value === "other") {
                                                                formik.setFieldValue("other_inspection_type", "");
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Select Inspection Type</option>
                                                        {typeofInspection?.map((type) => (
                                                            <option key={type.id} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                        <option value="other">Other</option>
                                                    </Input>

                                                    {formik.touched.type_of_inspection &&
                                                        formik.errors.type_of_inspection ? (
                                                        <div className="text-danger">
                                                            {formik.errors.type_of_inspection as string}
                                                        </div>
                                                    ) : null}

                                                </Col>

                                                <Col md={6}>
                                                    <Label htmlFor="Parent Company" className="form-label">Parent Company</Label>
                                                    <Input
                                                        type="text"
                                                        className=""
                                                        id="parent_company"
                                                        name="parent_company"
                                                        //@ts-ignore
                                                        value={companiesData?.[0]?.company_name || ""}
                                                        readOnly
                                                        disabled
                                                    />
                                                </Col>
                                            </Row>
                                            {formik.values.type_of_inspection === "other" && (
                                                <Row className="mb-3">
                                                    <Col md={4}>
                                                        <Label htmlFor="start_date" className="form-label">Others (Please State)<span className="text-danger">*</span></Label>
                                                        <Input
                                                            type="text"
                                                            className="form-control"
                                                            id="other_inspection_type"
                                                            name="other_inspection_type"
                                                            placeholder="Enter other inspection type"
                                                            value={formik.values.other_inspection_type}
                                                            onChange={formik.handleChange}
                                                        />
                                                        {formik.values.type_of_inspection === "other" && formik.errors.other_inspection_type && (
                                                            <span className="text-danger">{formik.errors.other_inspection_type as string}</span>
                                                        )}
                                                    </Col>
                                                </Row>
                                            )}
                                            <Row className="mb-3">
                                                <Col md={4}>
                                                    <Label htmlFor="start_date" className="form-label">Start Date <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="date"
                                                        className="form-control"
                                                        id="start_date"
                                                        name="start_date"
                                                        value={formik.values.start_date}
                                                        onChange={formik.handleChange}
                                                    />
                                                    {formik.touched.start_date &&
                                                        formik.errors.start_date ? (
                                                        <div className="text-danger">
                                                            {formik.errors.start_date as string}
                                                        </div>
                                                    ) : null}
                                                </Col>
                                                <Col md={4}>
                                                    <Label htmlFor="end_date" className="form-label">End Date <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="date"
                                                        className="form-control"
                                                        id="end_date"
                                                        name="end_date"
                                                        value={formik.values.end_date}
                                                        onChange={formik.handleChange}
                                                    />

                                                    {formik.touched.end_date &&
                                                        formik.errors.end_date ? (
                                                        <div className="text-danger">
                                                            {formik.errors.end_date as string}
                                                        </div>
                                                    ) : null}
                                                </Col>
                                            </Row>
                                            <div className="text-end">
                                                <Button color="primary" type="submit" disabled={isCreating || isUpdating}>
                                                    {isCreating || isUpdating ? <Spinner size="sm" /> : "Save Changes"}
                                                </Button>
                                            </div>
                                        </Form>
                                    </CardBody>
                                </Card>
                            }

                        </Card>

                        {reportData?.inspection_report_detail?.length > 0 && (
                            <div className="mt-4 mb-3 d-flex justify-content-center">
                                <Button
                                    color={activeFilter === 1 ? "success" : "secondary"}
                                    className="mx-2"
                                    onClick={() => filterReports(1)}
                                >
                                    GOOD PRACTICE ({goodPracticeCount})
                                </Button>
                                <Button
                                    className="mx-2"
                                    color={activeFilter === 2 ? "danger" : "secondary"}
                                    onClick={() => filterReports(2)}
                                >
                                    BAD PRACTICE ({badPracticeCount})
                                </Button>
                            </div>
                        )}


                        <Card>
                            <CardHeader className="d-flex justify-content-between">
                                <h5 className="card-title">Observation Report</h5>
                                {reportData?.report_status_name !== "Open" && !cardView && (
                                    <div>
                                        <Button
                                            color="success"
                                            className="mx-2"
                                            onClick={() => handlePracticeButtonClick("1")}
                                            disabled={!viewReport}
                                        >
                                            GOOD PRACTICE
                                        </Button>
                                        <Button
                                            color="danger"
                                            className="mx-2"
                                            onClick={() => handlePracticeButtonClick("2")}
                                            disabled={!viewReport}
                                        >
                                            BAD PRACTICE
                                        </Button>
                                    </div>
                                )}

                            </CardHeader>
                            <CardBody activeTab={activeTab} className="text-muted">
                            </CardBody>
                            {filteredData &&
                                filteredData?.length > 0 ? (
                                <div>
                                    {filteredData?.map((practice: any, index: any) => (
                                        <Card key={index}>
                                            <CardHeader className={`bg-${practice?.report_type === 2 ? "danger" : "success"} d-flex justify-content-between`} >
                                                <h4 className="text-white">
                                                    {practice?.title}
                                                </h4>
                                                {
                                                 //@ts-ignore   
                                                reportData?.report_status_name !== "Open" && !cardView && currentUser?.employee_uuid === reportData?.inspector_uuid && (
                                                    <Button
                                                        className="btn btn-soft-info btn-md shadow-none"
                                                        onClick={() => {
                                                            setModalFormData(practice);
                                                            setEditingReportId(practice?.id);
                                                            toggleModal();
                                                        }}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}

                                            </CardHeader>
                                            <CardBody>
                                                <div className="row bg-white rounded py-3 px-md-3 px-0 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="table-card">
                                                                <table className="table mb-0 mt-3">
                                                                    <tbody>

                                                                        <tr>
                                                                            <td
                                                                                className="fw-medium"
                                                                                style={{ width: "300px" }}
                                                                            >
                                                                                {" "}
                                                                                Name of Person Incharge
                                                                            </td>
                                                                            <td>{practice?.name_of_person_incharge_name}
                                                                                {(reportData?.report_status_name === "Open" &&

                                                                                    practice?.report_status_name !== "Work Completed" &&

                                                                                    practice?.report_type !== 1 &&

                                                                                    !cardView &&

                                                                                    //@ts-ignore
                                                                                    currentUser?.employee_uuid === practice?.name_of_person_incharge_uuid) && (
                                                                                        <Button
                                                                                            color="primary"
                                                                                            className="mx-2 btn-sm"
                                                                                            onClick={() => handleCorrectionButtonClick(practice?.id)}
                                                                                        >
                                                                                            <i className="ri-add-line align-bottom me-1"></i> ADD EVIDENCE
                                                                                        </Button>
                                                                                    )}
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-medium">Location</td>
                                                                            <td> {practice?.site_location}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-medium">Target Date</td>
                                                                            <td> {practice?.target_date}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="fw-medium" style={{ width: "300px" }}>
                                                                                Status:
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${getStatusClass(practice?.report_status_name)}`}>
                                                                                    {practice?.report_status_name}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <div className="col-md-6">
                                                            <div className="table-card">
                                                                <table className="table mb-0 mt-3">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="fw-medium" colSpan={2}><h5>Description of Findings</h5></td>
                                                                        </tr>

                                                                        {practice?.observation && (
                                                                            <tr>
                                                                                <td className="fw-medium">Observation:</td>
                                                                                <td> {practice?.observation}</td>
                                                                            </tr>
                                                                        )}
                                                                        {practice?.recommendation && (
                                                                            <tr>
                                                                                <td className="fw-medium">Recommendation:</td>
                                                                                <td> {practice?.recommendation}</td>
                                                                            </tr>
                                                                        )}
                                                                        {practice?.comments_report1 && (
                                                                            <tr>
                                                                                <td className="fw-medium">
                                                                                    Comments
                                                                                </td>
                                                                                <td>{practice?.comments_report1}</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p>
                                                                <strong>Attachment:</strong>{" "}
                                                            </p>
                                                            <div className="product-img-slider">
                                                                <Swiper
                                                                    modules={[Navigation, FreeMode]}
                                                                    navigation={true}
                                                                    className="swiper product-thumbnail-slider p-2 rounded bg-light"
                                                                >
                                                                    <div className="swiper-wrapper">
                                                                        {practice?.attachment1_url && (
                                                                            <SwiperSlide>
                                                                                <img
                                                                                    src={practice?.attachment1_url}
                                                                                    alt=""
                                                                                    className="img-fluid d-block"
                                                                                />
                                                                            </SwiperSlide>
                                                                        )}
                                                                    </div>
                                                                </Swiper>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="mt-4 mb-3 d-flex justify-content-center">
                                                </div>
                                                {practice?.report_status_name === "Work Completed" && <div className="row bg-white rounded py-3 px-md-3 px-0 mt-3">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="table-card">
                                                                <table className="table mb-0 mt-3">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="fw-medium" colSpan={2}><h5>Action Performed</h5></td>
                                                                        </tr>
                                                                        {practice?.corrective_actions && (
                                                                            <tr>
                                                                                <td className="fw-medium">Corrective Actions:</td>
                                                                                <td> {practice?.corrective_actions}</td>
                                                                            </tr>
                                                                        )}

                                                                        {practice?.preventive_actions && (
                                                                            <tr>
                                                                                <td className="fw-medium">Preventive Actions:</td>
                                                                                <td> {practice?.preventive_actions}</td>
                                                                            </tr>
                                                                        )}
                                                                        {practice?.comments_report2 && (
                                                                            <tr>
                                                                                <td className="fw-medium">
                                                                                    Comments report
                                                                                </td>
                                                                                <td>{practice?.comments_report2}</td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <p>
                                                                <strong>Attachment:</strong>{" "}
                                                            </p>
                                                            <div className="product-img-slider">
                                                                <Swiper
                                                                    modules={[Navigation, FreeMode]}
                                                                    navigation={true}
                                                                    className="swiper product-thumbnail-slider p-2 rounded bg-light"
                                                                >
                                                                    <div className="swiper-wrapper">

                                                                        {practice?.attachment2_url && (
                                                                            <SwiperSlide>
                                                                                <img
                                                                                    src={practice?.attachment2_url}
                                                                                    alt=""
                                                                                    className="img-fluid d-block"
                                                                                />
                                                                            </SwiperSlide>
                                                                        )}
                                                                    </div>
                                                                </Swiper>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </CardBody>
                                        </Card>
                                    ))}
                                </div>

                            ) : (
                                <div className="d-flex align-items-center justify-content-center">
                                    <div>
                                        <p>No inspection report details found.</p>
                                    </div>
                                </div>
                            )}
                            <CardFooter className="mt-4 mb-3 d-flex justify-content-end">
                                <div>
                                    {reportData?.report_status_name !== "Open" && !cardView && (
                                        <Button
                                            color="success"
                                            className="mx-2"
                                            disabled={
                                                !reportData?.inspection_report_detail?.length ||  // If inspection_report_detail is empty
                                                isCreating ||
                                                isUpdating ||
                                                isCreatingbyId
                                            }
                                            onClick={() => handleSubmitButtonClick(2)}
                                        >
                                            {isCreating || isUpdating ? <Spinner size="sm" /> : "Submit"}
                                        </Button>
                                    )}
                                    
                                    {
                                     //@ts-ignore
                                    allBadPracticeCompleted && reportData?.report_status_name === "Open" && !cardView && currentUser?.employee_uuid === reportData?.inspector_uuid && (
                                        <Button
                                            color="success"
                                            className="mx-2"
                                            disabled={
                                                !reportData?.inspection_report_detail?.length ||
                                                isCreating ||
                                                isUpdating ||
                                                isCreatingbyId
                                            }
                                            onClick={() => handleSubmitButtonClick(9)}
                                        >
                                            {isCreating || isUpdating ? <Spinner size="sm" /> : "Complete Action"}
                                        </Button>
                                    )}

                                    <Button
                                        color="danger"
                                        className="mx-2"
                                        disabled={isCreating || isUpdating || isCreatingbyId}
                                        onClick={() => navigate(`/report-list`)}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>


                        <Modal isOpen={modalOpen} toggle={toggleModal} size="lg">
                            <ModalHeader toggle={toggleModal}>
                                {practiceType === "1" ? "Good Practice" : "Bad Practice"} Details
                            </ModalHeader>
                            <ModalBody>
                                <Form onSubmit={practiceFormik.handleSubmit}>
                                    <Row className="mb-3">
                                    <Col md={6}>
                                            <Label htmlFor="title" className="form-label">Title <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="title"
                                                name="title"
                                                value={practiceFormik.values.title}
                                                onChange={practiceFormik.handleChange}
                                            />
                                            {practiceFormik.touched.title &&
                                                practiceFormik.errors.title ? (
                                                <div className="text-danger">
                                                    {practiceFormik.errors.title as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                        <Col md={6}>
                                            <Label htmlFor="site_location" className="form-label">Location <span className="text-danger">*</span></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="site_location"
                                                name="site_location"
                                                value={practiceFormik.values.site_location}
                                                onChange={practiceFormik.handleChange}
                                            />
                                            {practiceFormik.touched.site_location &&
                                                practiceFormik.errors.site_location ? (
                                                <div className="text-danger">
                                                    {practiceFormik.errors.site_location as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                       
                                        <Col md={6}>
                                            <Label htmlFor="start_date" className="form-label">Target Date <span className="text-danger">*</span></Label>
                                            <Input
                                                type="date"
                                                className="form-control"
                                                id="start_date"
                                                name="target_date"
                                                value={practiceFormik.values.target_date}
                                                onChange={practiceFormik.handleChange}
                                            />
                                            {practiceFormik.touched.target_date &&
                                                practiceFormik.errors.target_date ? (
                                                <div className="text-danger">
                                                    {practiceFormik.errors.target_date as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={6}>
                                            <Label htmlFor="work_assigned" className="form-label">Incharge Person <span className="text-danger">*</span></Label>
                                            <Input
                                                type="select"
                                                className="form-select"
                                                id="name_of_person_incharge"
                                                name="name_of_person_incharge"
                                                value={practiceFormik.values.name_of_person_incharge}
                                                onChange={(e) => {
                                                    const selectedEmployee = employeeData?.find(emp => emp.id === parseInt(e.target.value));
                                                    practiceFormik.setFieldValue("name_of_person_incharge", e.target.value);
                                                    practiceFormik.setFieldValue("name_of_person_incharge_uuid", selectedEmployee ? selectedEmployee.employee_uuid : "");
                                                }}
                                            >
                                                <option value="">Select Incharge Person</option>
                                                {employeeData?.map((employee) => (
                                                    <option key={employee.id} value={employee.id}>
                                                        {employee.employee_fullname}
                                                    </option>
                                                ))}
                                            </Input>
                                            {practiceFormik.touched.name_of_person_incharge &&
                                                practiceFormik.errors.name_of_person_incharge ? (
                                                <div className="text-danger">
                                                    {practiceFormik.errors.name_of_person_incharge as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                        <Col md={6}>
                                            <Label className="form-label">Upload Files</Label>
                                            <Input
                                                type="file"
                                                className="form-control"
                                                onChange={(event) => {
                                                    const file = event.target.files?.[0]; // Get the selected file
                                                    if (file) {
                                                        Object.assign(file, {
                                                            preview: URL.createObjectURL(file), // Generate preview URL
                                                        });
                                                        //@ts-ignore
                                                        setSelectedFiles([file]); // Store only one file
                                                    }
                                                }}
                                            />
                                            <p className="text-muted font-weight-bold mt-1">
                                                {
                                                    //@ts-ignore
                                                    selectedFiles[0]?.name
                                                }
                                            </p>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="observation_checkbox"
                                                checked={practiceFormik.values.checkedFields.observation}
                                                onChange={() =>
                                                    practiceFormik.setFieldValue(
                                                        "checkedFields.observation",
                                                        !practiceFormik.values.checkedFields.observation
                                                    )
                                                }
                                            />
                                            <Label htmlFor="observation_checkbox" className="ms-2">Observation</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="observation"
                                                value={practiceFormik.values.observation}
                                                onChange={practiceFormik.handleChange}
                                                readOnly={!practiceFormik.values.checkedFields.observation}
                                                className="form-control mt-2"
                                            />
                                        </Col>
                                        {practiceFormik.touched.checkedFields &&
                                            practiceFormik.errors.checkedFields ? (
                                            <div className="text-danger">
                                                {practiceFormik.errors.checkedFields as string}
                                            </div>
                                        ) : null}
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="recommendation_checkbox"
                                                checked={practiceFormik.values.checkedFields.recommendation}
                                                onChange={() =>
                                                    practiceFormik.setFieldValue(
                                                        "checkedFields.recommendation",
                                                        !practiceFormik.values.checkedFields.recommendation
                                                    )
                                                }
                                            />
                                            <Label htmlFor="recommendation_checkbox" className="ms-2">Recommendation</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="recommendation"
                                                value={practiceFormik.values.recommendation}
                                                onChange={practiceFormik.handleChange}
                                                readOnly={!practiceFormik.values.checkedFields.recommendation}
                                                className="form-control mt-2"
                                            />
                                        </Col>
                                        {practiceFormik.touched.checkedFields &&
                                            practiceFormik.errors.checkedFields ? (
                                            <div className="text-danger">
                                                {practiceFormik.errors.checkedFields as string}
                                            </div>
                                        ) : null}
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="comments_report1_checkbox"
                                                checked={practiceFormik.values.checkedFields.comments_report1}
                                                onChange={() =>
                                                    practiceFormik.setFieldValue(
                                                        "checkedFields.comments_report1",
                                                        !practiceFormik.values.checkedFields.comments_report1
                                                    )
                                                }
                                            />
                                            <Label htmlFor="comments_report1_checkbox" className="ms-2">Comments</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="comments_report1"
                                                value={practiceFormik.values.comments_report1}
                                                onChange={practiceFormik.handleChange}
                                                readOnly={!practiceFormik.values.checkedFields.comments_report1}
                                                className="form-control mt-2"
                                            />
                                            {practiceFormik.touched.checkedFields &&
                                                practiceFormik.errors.checkedFields ? (
                                                <div className="text-danger">
                                                    {practiceFormik.errors.checkedFields as string}
                                                </div>
                                            ) : null}

                                        </Col>
                                    </Row>
                                    <Row className="mb-3">

                                    </Row>
                                    <div className="modal-footer">
                                        <Button color="light" onClick={toggleModal}>
                                            Cancel
                                        </Button>
                                        <Button color="primary" type="submit" disabled={patchReportRowByIdloading || isCreatingbyId}>
                                            {isCreatingbyId || patchReportRowByIdloading ? <Spinner size="sm" /> : " Save"}
                                        </Button>
                                    </div>
                                </Form>
                            </ModalBody>
                        </Modal>

                        <Modal isOpen={correctionModalOpen} toggle={correctionToggleModal} size="lg">
                            <ModalHeader toggle={correctionToggleModal}>
                                Report Information
                            </ModalHeader>
                            <ModalBody>
                                <Form onSubmit={correctionFormik.handleSubmit}>
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Label className="form-label">Upload Files</Label>
                                            <Input
                                                type="file"
                                                className="form-control"
                                                onChange={(event) => {
                                                    const file = event.target.files?.[0]; // Get the selected file
                                                    if (file) {
                                                        Object.assign(file, {
                                                            preview: URL.createObjectURL(file), // Generate preview URL
                                                        });
                                                        //@ts-ignore
                                                        setSelectedFiles([file]); // Store only one file
                                                    }
                                                }}
                                            />
                                            <p className="text-muted font-weight-bold mt-1">
                                                {
                                                    //@ts-ignore
                                                    selectedFiles[0]?.name
                                                }
                                            </p>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="corrective_checkbox"
                                                checked={correctionFormik.values.checkedFields.corrective_actions}
                                                onChange={() =>
                                                    correctionFormik.setFieldValue(
                                                        "checkedFields.corrective_actions",
                                                        !correctionFormik.values.checkedFields.corrective_actions
                                                    )
                                                }
                                            />
                                            <Label htmlFor="corrective_checkbox" className="ms-2">Corrective Actions</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="corrective_actions"
                                                value={correctionFormik.values.corrective_actions}
                                                onChange={correctionFormik.handleChange}
                                                readOnly={!correctionFormik.values.checkedFields.corrective_actions} // Read-only when unchecked
                                                className="form-control mt-2"
                                            />
                                            {correctionFormik.touched.checkedFields &&
                                                correctionFormik.errors.checkedFields ? (
                                                <div className="text-danger">
                                                    {correctionFormik.errors.checkedFields as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="preventive_actions_checkbox"
                                                checked={correctionFormik.values.checkedFields.preventive_actions}
                                                onChange={() =>
                                                    correctionFormik.setFieldValue(
                                                        "checkedFields.preventive_actions",
                                                        !correctionFormik.values.checkedFields.preventive_actions
                                                    )
                                                }
                                            />
                                            <Label htmlFor="preventive_actions_checkbox" className="ms-2">Preventive Actions</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="preventive_actions"
                                                value={correctionFormik.values.preventive_actions}
                                                onChange={correctionFormik.handleChange}
                                                readOnly={!correctionFormik.values.checkedFields.preventive_actions} // Read-only when unchecked
                                                className="form-control mt-2"
                                            />
                                            {correctionFormik.touched.checkedFields &&
                                                correctionFormik.errors.checkedFields ? (
                                                <div className="text-danger">
                                                    {correctionFormik.errors.checkedFields as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Input
                                                type="checkbox"
                                                id="comments_report2_checkbox"
                                                checked={correctionFormik.values.checkedFields.comments_report2}
                                                onChange={() =>
                                                    correctionFormik.setFieldValue(
                                                        "checkedFields.comments_report2",
                                                        !correctionFormik.values.checkedFields.comments_report2
                                                    )
                                                }
                                            />
                                            <Label htmlFor="comments_report2_checkbox" className="ms-2">Comments</Label>
                                            <Input
                                                type="textarea"
                                                rows={4}
                                                name="comments_report2"
                                                value={correctionFormik.values.comments_report2}
                                                onChange={correctionFormik.handleChange}
                                                readOnly={!correctionFormik.values.checkedFields.comments_report2} // Read-only when unchecked
                                                className="form-control mt-2"
                                            />
                                            {correctionFormik.touched.checkedFields &&
                                                correctionFormik.errors.checkedFields ? (
                                                <div className="text-danger">
                                                    {correctionFormik.errors.checkedFields as string}
                                                </div>
                                            ) : null}
                                        </Col>
                                    </Row>

                                    <div className="modal-footer">
                                        <Button color="light" onClick={toggleModal}>
                                            Cancel
                                        </Button>

                                        <Button color="primary" type="submit" disabled={patchReportRowByIdloading || isCreatingbyId}>
                                            {isCreatingbyId || patchReportRowByIdloading ? <Spinner size="sm" /> : " Save"}
                                        </Button>
                                    </div>
                                </Form>
                            </ModalBody>
                        </Modal>
                    </Col>
                </Row>
                <ValidationAlertStatic
                    modalBackDrop={modalBackDrop}
                    setModalBackDrop={setModalBackDrop}
                    validationMessages={validationMessages}
                    previousPageNavLink="/report-list"
                />

            </Container>
        </div>
    )
}



export default InspectionReportForm;
